<template>
  <b-card style="padding:40px;">
    <h5><b>CHANGE PASSWORD</b></h5>
    <hr />
    <b-col md="12" style="padding:50px;">
      <center>
        <transition
          name="hint"
          appear
          style="border: 2px solid lightgrey; padding:20px;"
        >
          <div
            v-if="passwordValidation.errors.length > 0 && !submitted"
            class="hints"
          >
            <h3>Your Password Must Contain</h3>
            <p v-for="error in passwordValidation.errors" :key="error">
              {{ error }}
            </p>
          </div>
        </transition>

        <b-row>
          <b-col md="10">
            <b-form-group
              id="fieldset-horizontal"
              label-cols-md="4"
              label-cols-sm="5"
              label="Current Password"
              label-for="input-horizontal"
            >
              <b-form-input
                v-model="form.current_password"
                id="input-horizontal"
                class="input-new"
                :type="passwordVisible ? 'text' : 'password'"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="10">
            <b-form-group
              id="fieldset-horizontal"
              label-cols-md="4"
              label-cols-sm="5"
              label="New Password"
              label-for="input-horizontal"
            >
              <b-form-input
                v-model="new_password"
                :id="`input-new_pass`"
                :class="{ valid: passwordValidation.valid }"
                class="input-new"
                :type="passwordVisible ? 'text' : 'password'"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-button
              variant="danger"
              size="m"
              class="visibility"
              tabindex="-1"
              @click="togglePasswordVisibility"
              :arial-label="passwordVisible ? 'Hide password' : 'Show password'"
            >
              <i class="material-icons">{{
                passwordVisible ? "HIDE" : "SHOW"
              }}</i>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="10">
            <b-form-group
              id="fieldset-horizontal"
              label-cols-md="4"
              label-cols-sm="5"
              label="Re-Enter Password"
              label-for="input-horizontal"
            >
              <b-form-input
                v-model.lazy="checkPassword"
                :id="`input-reenter_pass`"
                class="input-new"
                :type="`password`"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group>
              <label class="matches" v-if="notSamePasswords"
                ><span class="required"> *</span>Password Dont Match<span
                  class="required"
                  >*</span
                ></label
              >
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <center>
              <b-form-group>
                <b-button
                  variant="primary"
                  size="sm"
                  align="left"
                  @click="onClickCancel"
                  >CANCEL</b-button
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button
                  variant="success"
                  size="sm"
                  @click="onClickSubmit"
                  v-if="
                    passwordsFilled &&
                      !notSamePasswords &&
                      passwordValidation.valid
                  "
                  >SUBMIT</b-button
                >
              </b-form-group>
            </center>
          </b-col>
        </b-row>
      </center>
    </b-col>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        current_password: "",
        user_id: ""
      },
      rules: [
        { message: "One lowercase letter required.", regex: /[a-z]+/ },
        { message: "One uppercase letter required.", regex: /[A-Z]+/ },
        { message: "8 characters minimum.", regex: /.{8,}/ },
        { message: "One number required.", regex: /[0-9]+/ }
      ],
      new_password: "",
      checkPassword: "",
      passwordVisible: false,
      submitted: false
    };
  },
  computed: {
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.new_password !== this.checkPassword;
      } else {
        return false;
      }
    },
    passwordsFilled() {
      return this.new_password !== "" && this.checkPassword !== "";
    },
    passwordValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.new_password)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    }
  },
  methods: {
    resetPasswords() {
      this.new_password = "";
      this.checkPassword = "";
      this.submitted = true;
      setTimeout(() => {
        this.submitted = false;
      }, 2000);
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
    onClickSubmit() {
      const form = {
        current_password: this.form.current_password,
        password: this.new_password,
        user_id: this.$store.getters.getUser_id
      };
      this.$store.dispatch("changePassword", form).then(res => {
        if (res.data.response.code === 1) {
          this.$router.go(-1);
        }
      });
    },
    onClickCancel() {
      // this.$router.go(-1);
      this.$router.push({ path: `/dashboard` });
    }
  }
};
</script>
<style lang="css" scoped></style>
